import script from "./ShareModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShareModal.vue?vue&type=script&setup=true&lang=ts"

import "./ShareModal.vue?vue&type=style&index=0&id=8b5599bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b5599bc"]])

export default __exports__